import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { Modal, Input, Button } from 'antd';

import { resetStats } from './../mutations/resetStats';
import './statsManagement.css';

class StatsManagement extends Component {
  state = {
    loading: false
  }

  get mutationParams() {
    return {
      variables: {
        input: {
          id: this.props.churchId
        }
      }
    };
  }

  async resetStats() {
    try {
      this.setState({ loading: true });
      const { data } = await this.props.mutate(this.mutationParams);
      Modal.success({
        title: "Stats reset!",
        onOk: () => this.props.history.push(`/dashboard/${this.props.churchId}/stats/church/daily`)
      });
    } catch (response) {
      Modal.error({
        title: 'Error',
        content: (
          <div>
            Something went wrong
          </div>
        ),
        width: 510
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  onReset = () => {
    Modal.confirm({
      title: `Are you sure you want to reset all statistics?`,
      okText: "RESET",
      width: 600,
      onOk: () => this.resetStats()
    });
  }

  render() {
    return (
      <div>
        <Button type="danger" onClick={this.onReset} loading={this.state.loading} className="reset-stats__button">
          RESET STATS
        </Button>
      </div>
    );
  }
}

export default graphql(resetStats)(StatsManagement);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/statsManagement.js